import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import template from 'lodash/template';
import { JSSClasses } from 'proptypes/jss-prop-types';
import { numberToCurrency } from 'utils/currency';
import Alert from 'components/alert/Alert';
import withLocale from 'components/withLocale/withLocale';

const styles = ({ spacing: { unit }, typography: { fontWeightMedium } }) => ({
  container: {
    width: '100%',
    fontSize: unit * 1.5
  },
  row: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    '& div:nth-child(1)': {
      width: '150px'
    },
    '& > div:nth-child(2)': {
      width: '100px'
    },
    '& > div:nth-child(3)': {
      width: '300px'
    }
  },
  heading: {
    fontWeight: fontWeightMedium,
    paddingRight: unit * 2,
    minWidth: '100px'
  },
  detail: {
    paddingRight: unit * 2,
    minWidth: '100px'
  },
  warning: {
    fontSize: unit * 1.5
  }
});

function PaymentsWireInsufficientFundsAlert({
  balanceCheckType,
  classes,
  errors,
  locale,
  onHide
}) {
  const getTitle = () => {
    return balanceCheckType === 0
      ? template(locale['payments.bulk.error'])({ count: errors.length })
      : locale['payments.bulk.warning'];
  };
  return (
    <Alert title={getTitle()} variant="warning" onHide={onHide} details>
      <section className={classes.container}>
        <div className={classes.row}>
          <div className={classes.heading}>{locale['payments.payeeName']}</div>
          <div className={classes.heading}>{locale['payments.amount']}</div>
          <div className={classes.heading}>{locale['payments.reason']}</div>
        </div>
        {errors.map((error) => (
          <div key={`errors-${error.payeeName}`} className={classes.row}>
            <div className={classes.detail}>{error.payeeName}</div>
            <div className={classes.detail}>{numberToCurrency(error.amount)}</div>
            <div className={classes.detail}>{error.reason}</div>
          </div>
        ))}
      </section>
    </Alert>
  );
}

PaymentsWireInsufficientFundsAlert.propTypes = {
  onHide: PropTypes.node.isRequired,
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: JSSClasses,
  locale: PropTypes.objectOf(PropTypes.string),
  balanceCheckType: PropTypes.string
};

PaymentsWireInsufficientFundsAlert.defaultProps = {
  classes: {},
  locale: {},
  balanceCheckType: ''
};

const PaymentsWireInsufficientFundsAlertStyled = withStyles(styles)(
  PaymentsWireInsufficientFundsAlert
);
const PaymentsWireInsufficientFundsAlertLocaled = withLocale(
  PaymentsWireInsufficientFundsAlertStyled
);
export default PaymentsWireInsufficientFundsAlertLocaled;
